import maxSize from 'popper-max-size-modifier';
export function getModifiers(_ref) {
  var matchWidths = _ref.matchWidths,
      offset = _ref.offset,
      keepInView = _ref.keepInView,
      shouldFlip = _ref.shouldFlip;
  return [// https://popper.js.org/docs/v2/modifiers/community-modifiers/
  maxSize, {
    name: 'applyMaxSize',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['maxSize'],
    fn: function fn(_ref2) {
      var state = _ref2.state;
      var height = state.modifiersData.maxSize.height;
      state.styles.popper.maxHeight = height + "px";
    }
  }, {
    name: 'matchWidths',
    enabled: Boolean(matchWidths),
    phase: 'write',
    requires: ['computeStyles'],
    effect: function effect(_ref3) {
      var state = _ref3.state;
      var offsetWidth = state.elements.reference.offsetWidth;

      if (matchWidths === 'minimum') {
        if (offsetWidth > state.elements.popper.offsetWidth) {
          state.elements.popper.style.minWidth = offsetWidth + "px";
        }
      } else {
        state.elements.popper.style.width = offsetWidth + "px";
      }
    }
  }, {
    name: 'offset',
    options: {
      offset: [0, offset]
    }
  }, {
    name: 'preventOverflow',
    enabled: keepInView
  }, {
    name: 'flip',
    enabled: shouldFlip
  }];
}
export function getFixedParent(node) {
  var offsetParent = node.offsetParent;

  if (offsetParent) {
    var offsetParentStyles = getComputedStyle(offsetParent);

    if (offsetParentStyles.position !== 'fixed') {
      return getFixedParent(offsetParent);
    } else {
      return offsetParent;
    }
  } else {
    return null;
  }
}